import React, { useState, useEffect } from "react";

const CyberToggle = ({
  isGlobalSearch,
  setIsGlobalSearch,
  isAdmin,
  canUseGlobalSearch,
  onVisibilityChange,
}) => {
  const [globalSearchEnabled, setGlobalSearchEnabled] = useState(true);
  const [loading, setLoading] = useState(true);

  // Загружаем настройку видимости Global Search
  useEffect(() => {
    const loadSetting = async () => {
      try {
        const response = await fetch(`/api/users/settings/global-search`, {
          headers: {
            Authorization: `tma ${window.Telegram.WebApp.initData}`,
          },
        });
        const data = await response.json();
        if (data.success) {
          setGlobalSearchEnabled(data.enabled);

          // Если настройка отключена и пользователь не админ, и он сейчас в режиме Global Search
          // автоматически переключаем его в обычный режим
          if (!data.enabled && !isAdmin && isGlobalSearch) {
            setIsGlobalSearch(false);
          }
        }
      } catch (error) {
        console.error("Error loading global search setting:", error);
        // По умолчанию оставляем включенным
        setGlobalSearchEnabled(true);
      } finally {
        setLoading(false);
      }
    };

    loadSetting();
  }, [isAdmin, isGlobalSearch, setIsGlobalSearch]);

  useEffect(() => {
    if (loading || !onVisibilityChange) return;
    onVisibilityChange(Boolean(globalSearchEnabled) || Boolean(isAdmin));
  }, [loading, globalSearchEnabled, isAdmin, onVisibilityChange]);

  // Показываем loading состояние (можно убрать если не нужно)
  if (loading) {
    return null;
  }

  // Если настройка отключена и пользователь не админ - полностью скрываем toggle
  if (!globalSearchEnabled && !isAdmin) {
    return null;
  }

  return (
    <div className="cyber-toggle-wrapper-search">
      <div className="flex items-center gap-3">
        <div className="cyber-toggle-wrapper-compact">
          <input
            className="cyber-toggle-checkbox"
            id="cyber-toggle"
            type="checkbox"
            checked={isGlobalSearch}
            onChange={(e) => setIsGlobalSearch(e.target.checked)}
          />
          <label className="cyber-toggle-compact" htmlFor="cyber-toggle">
            <div className="cyber-toggle-track">
              <div className="cyber-toggle-track-glow"></div>
              <div className="cyber-toggle-track-dots">
                <span className="cyber-toggle-track-dot"></span>
                <span className="cyber-toggle-track-dot"></span>
                <span className="cyber-toggle-track-dot"></span>
              </div>
            </div>
            <div className="cyber-toggle-thumb">
              <div className="cyber-toggle-thumb-shadow"></div>
              <div className="cyber-toggle-thumb-highlight"></div>
              <div className="cyber-toggle-thumb-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                >
                  <path
                    fill="#ffffff"
                    d="M2.05 13h5.477a17.9 17.9 0 0 0 2.925 8.88A10.005 10.005 0 0 1 2.049 13m0-2a10.005 10.005 0 0 1 8.402-8.881a17.9 17.9 0 0 0-2.925 8.88zm19.9 0h-5.477a17.9 17.9 0 0 0-2.925-8.881a10.005 10.005 0 0 1 8.403 8.88m0 2a10.005 10.005 0 0 1-8.402 8.88A17.9 17.9 0 0 0 16.473 13zM9.53 13h4.94A15.908 15.908 0 0 1 12 20.592A15.908 15.908 0 0 1 9.53 13m0-2A15.908 15.908 0 0 1 12 3.408A15.908 15.908 0 0 1 14.47 11z"
                  ></path>
                </svg>
              </div>
            </div>
            <div className="cyber-toggle-particles">
              <span className="cyber-toggle-particle"></span>
              <span className="cyber-toggle-particle"></span>
              <span className="cyber-toggle-particle"></span>
              <span className="cyber-toggle-particle"></span>
            </div>
          </label>
        </div>
        <div
          className={`font-medium text-sm uppercase tracking-wide transition-all duration-400 ${
            isGlobalSearch ? "text-[#03e9f4]" : "text-gray-500"
          }`}
          style={{
            textShadow: isGlobalSearch
              ? "0 0 8px rgba(3, 233, 244, 0.8), 0 0 15px rgba(3, 233, 244, 0.5)"
              : "none",
          }}
        >
          Global Search
        </div>
      </div>
    </div>
  );
};

export default CyberToggle;
